export default __webpack_public_path__ + "static/media/rehagro_azul.89c19974.png";